import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import close from "../../assets/images/close.png";
import { useSelector, useDispatch } from "react-redux";
import edit from "../../assets/images/edit.png";
import { userActions } from '../../actions/user.actions';
import {
  Modal,
  ModalHeader,
  ModalBody, Button,
  Form,
  Input, FormGroup,
  Label
} from 'reactstrap';
import axiosInstance from '../../helpers/axios';
import { Box } from '@mui/material';
import './index.css';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import MuiButton from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';

export default function ManageInstitutes(InstituteId) {
    const editstate = useSelector((state) => state.Editform?.res);
    const savedstate = useSelector((state)=> state.Updateeditform?.res)
    const [formOpen, setFormOpen] = useState(false);
    const [updateInstituteName,setUpdateInstituteName]=useState('');
    const [updateInstituteCode,setUpdateInstituteCode]=useState('');
    const [updateInstituteEmail,setUpdateInstituteEmail]=useState('');
    const [gstApplicableCheck, setGSTApplicableCheck] = useState(false);
    const [updateInstituteContact,setUpdateInstituteContact]=useState('');
    const [updateInstituteLogo,setUpdateInstituteLogo]=useState('');
    const [updateInstituteAddress,setUpdateInstituteAddress]=useState('');
    const [updateInstituteState,setUpdateInstituteState]=useState('');
    const [updateInstituteCity,setUpdateInstituteCity]=useState('');
    const [updateInstituteGst,setUpdateInstituteGst]=useState('');
    const [updateInstitutePincode,setUpdateInstitutePincode]=useState('');
    const [selectedInstitute,setSelectedInstitute]=useState(null)
    const [updateGstNumber, setUpdateGSTNumber] = useState('');
    const [savedFileEntries, setSavedFileEntries] = useState([{}])
    const [fileEntries, setFileEntries] = useState([{ fileName: '', file: null, url:null }])
    const [viewFile, setViewFile] = useState(false)
    const [selectedFileName, setSelectedFileName] = useState('')
    const [fileUrl, setFileUrl] = useState(null)
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [partnerId,setPartnerId] = useState("")
    const [partnerName,setPartnerName]=useState(InstituteId?.InstituteId?.partnerName || '');
    const [notes, setNotes] = useState('');
    const [notifyDisbursements, setNotifyDisbursements] = useState(false);
    const [notifyRefunds, setNotifyRefunds] = useState(false);
    const [notifyT3Reminders, setNotifyT3Reminders] = useState(false);
    const [notifyBounces, setNotifyBounces] = useState(false);
    const [fibeMid, setFibeMid] = useState('');
    const [fibeMidInput, setFibeMidInput] = useState('');
    const [fibeMidLoading, setFibeMidLoading] = useState(false);
    const [fibeMidEditing, setFibeMidEditing] = useState(false);
  const [activeTab, setActiveTab] = useState("manageInstitute");
  const [courseList, setCourseList] = useState([]);
  const [coursePage, setCoursePage] = useState(1);
  const [coursesPerPage, setCoursesPerPage] = useState(10);
  const [totalCourseRows, setTotalCourseRows] = useState(0);
  const [courseLoading, setCourseLoading] = useState(false);
  const [courseError, setCourseError] = useState("");
  const [statusUpdatingId, setStatusUpdatingId] = useState(null);
  const [courseName, setCourseName] = useState("");
  const [courseFees, setCourseFees] = useState("");
  const [createCourseLoading, setCreateCourseLoading] = useState(false);
  const [courseFilterStatus, setCourseFilterStatus] = useState("");
  const [selectedCourseForStatus, setSelectedCourseForStatus] = useState(null);
  const [showCreateCoursePopup, setShowCreateCoursePopup] = useState(false);
  const [courseSearchText, setCourseSearchText] = useState("");
  const [courseSearchResults, setCourseSearchResults] = useState([]);
  const [showCourseSearchResults, setShowCourseSearchResults] = useState(false);
  const [isCourseSearchMode, setIsCourseSearchMode] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState("");
    useEffect(() => {
      if (InstituteId?.InstituteId) {
        setNotifyDisbursements(InstituteId.InstituteId.notifyDisbursements || false);
        setNotifyRefunds(InstituteId.InstituteId.notifyRefunds || false);
        setNotifyT3Reminders(InstituteId.InstituteId.notifyTminus3Reminders || false);
        setNotifyBounces(InstituteId.InstituteId.notifyBounces || false);
        setFibeMid(InstituteId.InstituteId.fibeMid || "");
        setFundSource(InstituteId.InstituteId.fundSource?.toString() || '');
      }
    }, [InstituteId]);
    const handleStatusChange = (event) => {
      setSelectedStatus(event.target.value);
    };
    const handleCategoryChange = (event) => {
      setSelectedCategory(event.target.value);
    };
    const [signatoryDesignation, setSignatoryDesignation] = useState('');
    const [signatoryName, setSignatoryName] = useState('');
    const [fundSource, setFundSource] = useState('');
    const [emails, setEmails] = useState([]);
    const [currentEmail, setCurrentEmail] = useState('');
    const dispatch = useDispatch();
    useEffect(() => {

      if (InstituteId?.InstituteId?.category) {
        setSelectedCategory(InstituteId?.InstituteId?.category.toString());
      }
      if (InstituteId?.InstituteId?.status !== undefined && InstituteId?.InstituteId?.status !== null) {
        setSelectedStatus(InstituteId?.InstituteId?.status.toString());
      }
    }, [InstituteId]);

    useEffect(() => {
      if (InstituteId?.InstituteId?.mouFiles) {
        try {
          if((InstituteId?.InstituteId?.mouFiles==='[]')){
            setSavedFileEntries([{}])
          }
          else{
            setSavedFileEntries(JSON.parse(InstituteId.InstituteId.mouFiles));
          }
        } catch (error) {
          console.error("Error parsing mouFiles", error);
        }
      }
    }, [InstituteId]);

    const location = useLocation();
    
    const handleSaveFibeMid = async() =>{
       if (!fibeMidInput.trim()) return;
        setFibeMidLoading(true);
        try {
          const res = await axiosInstance.post(`fund_source/create/lender`, {
            fundCode:"FIB",
            instituteId: InstituteId?.InstituteId?.id,
            merchantId: fibeMidInput.trim(),
            status:0
          });
          setFibeMid(fibeMidInput.trim());
          setFibeMidEditing(false);
          alert('Fibe MID saved successfully');
        } catch (err) {
          alert('Failed to save Fibe MID: ' + err);
        } finally {
          setFibeMidLoading(false);
        }
    }

  //const { user } = useUserAuth();
  
  const user = null;const updateDetailsOfInstitute=()=>{
    const totalFiles = [...savedFileEntries, ...fileEntries];
    const mouFiles = totalFiles.filter(obj => 
        obj.fileName || obj.url || obj.file
    );

    const orig = InstituteId?.InstituteId || {};
    const getInputValue = (id) => {
      const el = document.getElementById(id);
      if (!el) return undefined;
      const val = el.value;
      if (val === "") return undefined;
      return val;
    }

    const filteredMouFiles = mouFiles.filter(obj => obj.fileName || obj.url || obj.file);

    const newValues = {
      code: updateInstituteCode || getInputValue("insCode"),
      name: updateInstituteName || getInputValue("insName"),
      email: updateInstituteEmail || getInputValue("insEmail"),
      contact: updateInstituteContact || getInputValue("insContact"),
      address: updateInstituteAddress || getInputValue("insAddress"),
      city: updateInstituteCity || getInputValue("insCity"),
      gstNumber: updateGstNumber || getInputValue("insGst"),
      state: updateInstituteState || getInputValue("insState"),
      pincode: updateInstitutePincode || getInputValue("insPincode"),
      category: selectedCategory !== "" ? Number(selectedCategory) : undefined,
      partnerId: partnerId || undefined,
      notes: notes || getInputValue("notes"),
      signatoryDesignation: signatoryDesignation || getInputValue("signatoryDesignation"),
      signatoryName: signatoryName || getInputValue("signatoryName"),
      refundPocEmails: emails.length ? emails : undefined,
      mouFilesStr: filteredMouFiles.length ? JSON.stringify(filteredMouFiles) : undefined,
      status: selectedStatus !== "" ? Number(selectedStatus) : undefined,
      notifyDisbursements: notifyDisbursements,
      notifyRefunds: notifyRefunds,
      notifyTminus3Reminders: notifyT3Reminders,
      notifyBounces: notifyBounces,
      fundSource: fundSource !== '' ? Number(fundSource) : undefined,
    };

    const buildPayload = (logoUrl) => {
      const payload = { id: orig.id };

      const addIfChanged = (key, value) => {
        if (value === undefined) return;
        const origVal = orig[key];
        if (key === 'mouFiles') {
          if ((orig.mouFiles || null) !== value) payload.mouFiles = value;
          return;
        }
        if (key === 'refundPocEmails') {
          if (JSON.stringify(origVal || []) !== JSON.stringify(value || [])) payload.refundPocEmails = value;
          return;
        }
        if (String(origVal) !== String(value)) payload[key] = value;
      };

      addIfChanged('code', newValues.code);
      addIfChanged('name', newValues.name);
      addIfChanged('email', newValues.email);
      addIfChanged('contact', newValues.contact);
      addIfChanged('address', newValues.address);
      addIfChanged('city', newValues.city);
      addIfChanged('gstNumber', newValues.gstNumber);
      // gstApplicable: only compute and include if gstNumber actually changed
      if (newValues.gstNumber !== undefined && String(newValues.gstNumber) !== String(orig.gstNumber || '')) {
        const gstApplicable = !!(newValues.gstNumber);
        if (gstApplicable !== orig.gstApplicable) payload.gstApplicable = gstApplicable;
      }
      addIfChanged('state', newValues.state);
      addIfChanged('pincode', newValues.pincode);
      addIfChanged('category', newValues.category);
      addIfChanged('partnerId', newValues.partnerId);
      addIfChanged('notes', newValues.notes);
      addIfChanged('signatoryDesignation', newValues.signatoryDesignation);
      addIfChanged('signatoryName', newValues.signatoryName);
      addIfChanged('status', newValues.status);
      addIfChanged('notifyDisbursements', newValues.notifyDisbursements);
      addIfChanged('notifyRefunds', newValues.notifyRefunds);
      addIfChanged('notifyTminus3Reminders', newValues.notifyTminus3Reminders);
      addIfChanged('notifyBounces', newValues.notifyBounces);
      addIfChanged('fundSource', newValues.fundSource);

      // mouFiles compare using string (only add if there are actual files)
      addIfChanged('mouFiles', newValues.mouFilesStr);

      // refund emails
      if (newValues.refundPocEmails !== undefined) addIfChanged('refundPocEmails', newValues.refundPocEmails);

      // include logo if present
      if (logoUrl) payload.logo = logoUrl;

      return payload;
    };

    const updateInstituteDetailsUrl=`/institute/info/edit`

    if (updateInstituteLogo) {
      const fileData = new FormData();
      fileData.append('file', updateInstituteLogo);
      fileData.append('type', 'logo');
      axiosInstance.post(`/file/upload`, fileData)
        .then((res) => {
          const logoUrl = res?.data?.data?.s3Url;
          const payload = buildPayload(logoUrl);
          if (Object.keys(payload).length <= 1) {
            alert('No changes to update');
            return;
          }
          dispatch(userActions.updateInstitutedetails(updateInstituteDetailsUrl, payload, user));
        })
        .catch((err) => {
          alert(err);
        });
    } else {
      const payload = buildPayload();
      if (Object.keys(payload).length <= 1) {
        alert('No changes to update');
        return;
      }
      dispatch(userActions.updateInstitutedetails(updateInstituteDetailsUrl, payload, user));
    }
  }
  
  const popUpForm = () => {
    setFormOpen(true);
  }

  const handleViewFile = (file) => {
    const extractedString = file?.url?.substring(file?.url?.indexOf("MOU"));
    const url = `/file/url-content?path=${extractedString}`
    axiosInstance
        .get(url, {
          headers: {
          },
        })
        .then((res)=>{
          setFileUrl(res?.data?.data)
          })
        .catch(e => {
          alert(e)
        })
    setSelectedFileName(file?.fileName)
    setViewFile(!viewFile)
  }

  const getS3FileUrl = async (newFile) => {
    const file=new FormData();
    file.append('file',newFile)
    file.append('type',"MOU")
    try {
        const response = await axiosInstance.post(`/file/upload`,file)
        const s3Url = await response.data.data.s3Url
        return s3Url

        
    } catch (error) {
        alert(`${error}, Please Reupload MOU`)
    }
  }

  const handleDeleteFile = (index) => {
    const updatedFiles = savedFileEntries.filter((item, i) => i !== index)
    if(updatedFiles?.length === 0){
      setSavedFileEntries([{}])
      return
    }
    setSavedFileEntries(updatedFiles)
  }

const handleFileNameChange = (index, value) => {
  setFileEntries((prevEntries) =>
    prevEntries.map((entry, i) =>
      i === index ? { ...entry, fileName: value } : entry
    )
  );
};

const handleAddMoreFiles = () => {
  setFileEntries([...fileEntries, { fileName: '', file: null, url:null }]);

}

const handleRemoveFiles =(index) => {
  setFileEntries((prevEntries) => prevEntries.filter((_, i) => i !== index));
}

const handleFileChange = async (index, file) => {
  const url =  await getS3FileUrl(file)
  setFileEntries((prevEntries) =>
    prevEntries.map((entry, i) =>
      i === index ? { ...entry, file, url } : entry
    )
  );
};

const hanldeClearFile = () => {
  setFileEntries([{}])
}
const [partnerList,setPartnerList]=useState(null)
const handleChange = (e) => {
  setPartnerName(e.target.value);
  getPartnerInfo(e.target.value);
};
const getPartnerInfo=(text)=>{
  const urlGetInstitute=`channel-partners/name?name=${text}`;
    
  if(text.length>=4)
  {
   axiosInstance.get(urlGetInstitute)
   .then((res)=>{
    setPartnerList(res?.data?.data)
   })
   .catch((err)=>{})
  }
  else{
    setPartnerList(null)
  }
}
const partnerDetails=(data)=>{
  setPartnerName(data?.name)
  setPartnerId(data?.partnerId)
  setPartnerList(null)

}
  const instituteId = InstituteId?.InstituteId?.id;
  const fetchCourses = async (
    status = courseFilterStatus, 
    customInstituteId = instituteId, 
    page = coursePage,
    searchText = courseSearchText,
  ) => {
    if (!customInstituteId) return;
    setCourseLoading(true);
    setCourseError("");
    try {
      let url = `/institute/course/all?instituteId=${customInstituteId}&perPage=${coursesPerPage}&pageNo=${page}`;
      if (status !== "") {
        url += `&status=${status}`;
      }
      if (searchText && searchText.trim().length >= 1) {
        url += `&name=${encodeURIComponent(searchText.trim())}`;
      }

const res = await axiosInstance.get(url, {
        headers: {
        },
      });

      const responseData = res?.data?.data || [];

      if (Array.isArray(responseData)) {
        setCourseList(responseData);
        setCoursePage(1);
        setCoursesPerPage(10);
        setTotalCourseRows(responseData.length);
      } else {
        setCourseList(responseData?.courses || []);
        setCoursePage(responseData?.pagination?.currentPage || 1);
        setCoursesPerPage(responseData?.pagination?.perPage || 10);
        setTotalCourseRows(responseData?.pagination?.totalRows || 0);
      }
    } catch (error) {
      setCourseError(error?.response?.data?.message || "failed to fetch course info");
    } finally {
      setCourseLoading(false);
    }
  };

  const fetchSelectedCourseById = async (id, status = courseFilterStatus) => {
    if (!id) return;
    setCourseLoading(true);
    setCourseError("");
  try {
      let url = `/institute/course/selected?id=${id}`;

      if (status !== "") {
        url += `&status=${status}`;
      }

      const res = await axiosInstance.get(url, {
        headers: {
        },
      });

      const course = res?.data?.data;
      if (!course) {
        setCourseList([]);
        setCoursePage(1);
        setCoursesPerPage(10);
        setTotalCourseRows(0);
        return;
      }
      setCourseList([course]);
      setCoursePage(1);
      setCoursesPerPage(10);
      setTotalCourseRows(1);
    } catch (error) {
      setCourseError(error?.response?.data?.message || "failed to fetch selected course");
      setCourseList([]);
      setTotalCourseRows(0);
    } finally {
      setCourseLoading(false);
    }
  };
  const searchCoursesByName = async (text) => {
    setCourseSearchText(text);
    setSelectedCourseId("");
    if (!text || text.trim().length < 4) {
      setCourseSearchResults([]);
      setShowCourseSearchResults(false);
      setIsCourseSearchMode(false);
      return;
    }
    try {
      const res = await axiosInstance.get(
        `/institute/course/search?instituteId=${instituteId}&name=${text.trim()}&perPage=${coursesPerPage}&pageNo=1`,
        {
          headers: {
          },
        }
      );
      const responseData = res?.data?.data || [];

      if (Array.isArray(responseData)) {
        setCourseSearchResults(responseData);
        setShowCourseSearchResults(true);
        setIsCourseSearchMode(true);
        
      } else {
        setCourseSearchResults(responseData?.courses || []);
        setShowCourseSearchResults(true);
        setIsCourseSearchMode(true);

      
      }
    } catch (error) {
      console.error("Error searching courses:", error);
      setCourseSearchResults([]);
      setShowCourseSearchResults(false);
      setIsCourseSearchMode(false);
    }
  };

  const handleSelectSearchedCourse = async(course) => {
    setCourseSearchText(course.courseName || "");
    setShowCourseSearchResults(false);
    setIsCourseSearchMode(true);
    setSelectedCourseId(course.id || "");
    await fetchSelectedCourseById(course.id, courseFilterStatus);
};
  const handleClearCourseSearch = async () => {
    setCourseSearchText("");
    setCourseSearchResults([]);
    setShowCourseSearchResults(false);
    setIsCourseSearchMode(false);
    setSelectedCourseId("");

    await fetchCourses(courseFilterStatus, instituteId, 1, "");
  };
  const handleClearCourseFilters = async () => {
    setCourseSearchText("");
    setCourseSearchResults([]);
    setShowCourseSearchResults(false);
    setIsCourseSearchMode(false);
    setSelectedCourseId("");
    setCourseFilterStatus("");

    await fetchCourses("", instituteId, 1, "");
  };
  const totalCoursePages = Math.ceil(totalCourseRows / coursesPerPage);
  const handleCreateCourse = async () => {
    if (!instituteId) {
      alert("Institute id not found");
      return;
    }
   if (!courseName.trim()) {
      alert("Please enter course name");
      return;
    }
   if (!courseFees) {
      alert("Please enter course fees");
      return;
    }
    try {
      setCreateCourseLoading(true);
      await axiosInstance.post("/institute/course/create",
        {
          instituteId: instituteId,
          courseName: courseName.trim(),
          fees: courseFees,
        },
        {
          headers: {
          },
        }
      );
      setCourseName("");
      setCourseFees("");
      setShowCreateCoursePopup(false);

      await fetchCourses();
    } catch (error) {
      console.error("Error creating course:", error);
      alert(error?.response?.data?.message || "Failed to create course");
    } finally {
      setCreateCourseLoading(false);
    }
  };
  const openCourseStatusPopup = (course) => {
    setSelectedCourseForStatus(course);
  };
  const handleCourseStatusChange = async (course) => {
    try {
      setStatusUpdatingId(course.id);
     const payload = {
        id: course.id,
        status: Number(!course.status),
      };
      await axiosInstance.post(`/institute/course/update-status`, payload, {
        headers: {
        },
      });

     setCourseList((prev) =>
        prev.map((item) =>
          item.id === course.id ? { ...item, status: !item.status } : item
        )
      );
      setSelectedCourseForStatus(null);
    } catch (error) {
      console.error("Error updating course status:", error);
      alert(error?.response?.data?.message || "Failed to update status");
    } finally {
      setStatusUpdatingId(null);
    }
  };
  useEffect(() => {
    if (formOpen && activeTab === "courseInfo") {
      setCourseSearchText("");
      setCourseSearchResults([]);
      setShowCourseSearchResults(false);
      fetchCourses();
    }
  }, [formOpen, activeTab,instituteId]);
  return (
    <div>
     <img style={{height:'16px',width:'16px'}} onClick={() => popUpForm()} src={edit}/>
      {formOpen && (
      <>
     <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 999,
        }}
      ></div>
      <Modal 
      style={{
        backgroundColor: 'white',maxWidth: '80%'}} size="lg" className='edit-form ' isOpen={formOpen}>
          <div style={{overflowY:'auto'}}>
              <div style={{ borderTopLeftRadius: '10px', borderTopRightRadius: "10px", display: "flex", justifyContent: "space-between", backgroundColor: "#E9E9E9", height: "50px", padding: "0 16px" }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                
                  <span
                    onClick={() => setActiveTab("manageInstitute")}
                    style={{
                      cursor: 'pointer',
                      fontWeight: activeTab === "manageInstitute" ? '600' : '400',
                      color: activeTab === "manageInstitute" ? '#D32028' : '#333',
                      borderBottom: activeTab === "manageInstitute" ? '2px solid #D32028' : 'none',
                      paddingBottom: '4px'
                    }}
                  >
                    Manage Institute
                  </span>
              
                  <span
                    onClick={() => setActiveTab("courseInfo")}
                    style={{
                      cursor: 'pointer',
                      fontWeight: activeTab === "courseInfo" ? '600' : '400',
                      color: activeTab === "courseInfo" ? '#D32028' : '#333',
                      borderBottom: activeTab === "courseInfo" ? '2px solid #D32028' : 'none',
                      paddingBottom: '4px',
                      marginLeft:'20px'
                    }}
                  >
                    Course Info
                  </span>
                  </div>
          <img style={{height:'1.5em',width:'1.5em',marginTop:'10px',cursor:'pointer'}}  className="image1" onClick={()=>setFormOpen(!formOpen)} src={close}/>
          </div>
        
        <ModalBody>
                {activeTab === "manageInstitute" ? (
          <Form>
            <FormGroup>
            <div>
                      <div style={{display:'flex',justifyContent: 'space-between',}}>
                        <div style={{display:'block'}}>
                            <p style={{fontWeight:'600'}}> Institute Name</p>
                            <Input style={{width:'17em',marginRight:'1em'}} id="insName" placeholder="Update Institute Name" defaultValue={InstituteId?.InstituteId?.brandName || ''} onChange={(e)=>setUpdateInstituteName(e.target.value)}/>
                        </div>
                        
                        <div style={{display:'block'}}>
                            <p style={{fontWeight:'600'}}> Institute Code</p>
                            <Input style={{width:'17em',marginRight:'1em'}} id="insCode" placeholder="Update Institute Name" defaultValue={InstituteId?.InstituteId?.code || ''} onChange={(e)=>setUpdateInstituteCode(e.target.value)}/>
                        </div>
                        <div style={{display:'block'}}>
                            <p style={{fontWeight:'600'}}> Institute Email</p>
                            <Input style={{width:'17em'}} id="insEmail" placeholder="Update Institute Email" defaultValue={InstituteId?.InstituteId?.email || ''} onChange={(e)=>setUpdateInstituteEmail(e.target.value)}/>
                        </div>
                       
                        <div style={{display:'block'}}>
                            <p style={{fontWeight:'600'}}> Institute Contact</p>
                            <Input style={{width:'17em'}} id="insContact" placeholder="Update Institute Contact" defaultValue={InstituteId?.InstituteId?.phone || ''} onChange={(e)=>setUpdateInstituteContact(e.target.value)}/>
                        </div>
                            
                      </div>
                      <div style={{display:'flex',justifyContent: 'space-between',marginTop:'2em'}}>
                     
                        
                        <div style={{display:'block'}}>
                        <p style={{fontWeight:'600'}}> Institute Address</p>
                            <Input style={{width:'17em',marginBottom:'0.5em'}} id="insAddress" placeholder="Update Institute Address" defaultValue={InstituteId?.InstituteId?.address || ''} onChange={(e)=>setUpdateInstituteAddress(e.target.value)}/>
                        </div>
                        <div style={{display:'block'}}>
                        <p style={{fontWeight:'600'}}> Institute City</p>
                            <Input style={{width:'17em',marginBottom:'0.5em'}} id="insCity" placeholder="Update Institute City" defaultValue={InstituteId?.InstituteId?.city || ''} onChange={(e)=>setUpdateInstituteCity(e.target.value)}/>
                        </div>
                       
                        <div style={{display:'block'}}>
                      <p style={{fontWeight:'600'}}> Institute State</p>
                            <Input style={{width:'17em',marginBottom:'0.5em'}} id="insState" placeholder="Update Institute State" defaultValue={InstituteId?.InstituteId?.state || ''} onChange={(e)=>setUpdateInstituteState(e.target.value)}/>
                        </div>
                        <div style={{display:'block'}}>
                        <p style={{fontWeight:'600'}}> Institute Pincode</p>
                            <Input style={{width:'17em',marginBottom:'0.5em'}} id="insPincode" placeholder="Update Institute Pincode" defaultValue={InstituteId?.InstituteId?.pincode || ''} onChange={(e)=>setUpdateInstitutePincode(e.target.value)}/>
                        </div>
                      </div>
                      <div style={{display:'flex',justifyContent: 'space-between',marginTop:'2em'}}>
                      <div style={{display:'block'}}>
                        <p style={{fontWeight:'600'}}> Partner Name</p>
                            <Input style={{width:'17em',marginBottom:'0.5em'}} id="PartnerName" placeholder="PartnerName" value={partnerName} onChange={handleChange}/>
                            {
                          partnerList?partnerList.map((item)=>{
                          return(
                            <div onClick={()=>partnerDetails(item)} className="instituteName" style={{border:'1px solid grey',borderRadius:'0.5em'}}>
                            <p  style={{fontWeight:'600',paddingTop:'0.5em',paddingLeft:'0.5em'}}>{item.name}</p>
                            </div>
                          )
                          }
                          ):<div/>
                        }
                        </div>
                      <div style={{display:'block'}}>
                        <p style={{fontWeight:'600'}}> Institute Category</p>
                        <select   id="instituteCategory"  name="instituteCategory" value={selectedCategory} onChange={handleCategoryChange} style={{width:'17em',height:'2.5em',padding:'0.6em',border:'1px solid #D0D0D0',borderRadius:'5px'}}  >
                          <option value="Select">Select</option>
                          <option value="1">K-12</option>
                          <option value="2">College</option>
                          <option value="3">UpSkilling</option>
                          <option value="4">Exec Ed</option>
                          <option value="5">Other</option>
                      </select>                         
                      </div>
                      <div style={{display:'block'}}>
                            <p style={{fontWeight:'600'}}> Institute Logo</p>
                            <Input type="file"style={{width:'17em'}} placeholder="Update Institute Logo" id="logo"  defaultValue={selectedInstitute?.logo} onChange={(e)=>setUpdateInstituteLogo(e.target.files[0])}/>
                            {/* {InstituteId?.logo?<img style={{width:'10em',height:'10em',}} src={InstituteId?.logo} alt="logo"/>:null} */}
                            
                        </div>
                      <div style={{display:'block'}}>
                      <p style={{fontWeight:'600'}}><span >GST Number</span></p>
                        <Input style={{width:'17em',marginBottom:'0.5em'}} id="insGst" defaultValue={InstituteId?.InstituteId?.gstNumber || ''} onChange={(e)=>setUpdateGSTNumber(e.target.value)} type="text" placeholder="GST Number"/> 
                      </div>
                      </div>
                      <div style={{display:'flex',justifyContent:'space-between'}}>
                      <div>
                        
                        {
                          <>
                          <Label htmlFor="logo"><span style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'600'}}>MOU</span></Label>
                          <MuiButton variant='outlined' sx={{textTransform:'none', ml:3}} size='small' color='secondary' onClick={hanldeClearFile}>Clear</MuiButton>
                          <div>
                            {fileEntries?.map((entry, index) => {
                              return (
                                <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px'}}>
                                  <Input
                                    type="text"
                                    placeholder="Enter File Name"
                                    value={entry.fileName}
                                    onChange={(e) => handleFileNameChange(index, e.target.value)}
                                    style={{ maxWidth: 230, marginRight: '10px' }}
                                  />
                                  <Input 
                                    type="file"
                                    name="file1"
                                    id="logo"
                                    placeholder="Institute Contact here"
                                    onChange={(e) => handleFileChange(index, e.target.files[0])}
                                    style={{ marginLeft:'5px',width: 300,}}
                                    
                                  />
                                  {index !==0 && <RemoveCircleOutlineIcon sx={{cursor:'pointer'}} onClick={() => handleRemoveFiles(index)}  fontSize='small'/>}
                                  <AddCircleIcon sx={{cursor:'pointer'}} onClick={handleAddMoreFiles} fontSize='small'/>
                                </Box>
                              )
                            })}
                          </div>
                        {
                          Object.keys(savedFileEntries[0]).length > 0 &&
                          <>
                          {
                          savedFileEntries?.map((entry, index)=> {
                            return(
                              <Box className='file-card'>
                              <p>{`Uploaded File - ${entry?.fileName}`}</p>
                              <VisibilityOutlinedIcon  onClick={() => handleViewFile(entry)} sx={{cursor:'pointer'}}/>
                              <DeleteIcon fontSize='small' onClick={() => handleDeleteFile(index)} sx={{cursor:'pointer', m:0}}/>
                              {
                                viewFile && (
                                    <Modal isOpen={viewFile}  size="xl" style={{height:'100%'}}>  
                                      <ModalHeader toggle={() => handleViewFile(entry?.url)}>{selectedFileName}</ModalHeader>
                                      <ModalBody >
                                      <iframe
                                          src={fileUrl}
                                          width="100%"
                                          height="600vh"
                                          style={{ border: 'none' }}
                                        ></iframe>
                                        {}
                                      </ModalBody>
                                    </Modal>
                                )
                              }
                              </Box>
                            )
                          })
                        }
                          </>
                        }
                        {/* email-chipsstyleinputs, */}
                     
                        </>
                        }
                        
                      </div>
                      
                        <div style={{display:'block'}}>
                        <p style={{fontWeight:'600'}}> Institute Status</p>
                        <select id="instituteStatus" name="instituteStatus" value={selectedStatus} onChange={handleStatusChange} style={{width:'17em',height:'2.5em',padding:'0.6em',border:'1px solid #D0D0D0',borderRadius:'5px'}}>
                          <option value="">Select</option>
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </div> 
                      
                      </div>
                      <div style={{display:'flex',justifyContent:'space-between',marginTop:'1em',padding:'1em'}}>
                        <div>
                          <input type="checkbox" checked={notifyDisbursements} onChange={(e) => setNotifyDisbursements(e.target.checked)} /> Notify Disbursements
                        </div>
                        <div>
                          <input type="checkbox" checked={notifyT3Reminders} onChange={(e) => setNotifyT3Reminders(e.target.checked)} /> Notify T-3 Reminders
                        </div>
                        <div>
                          <input type="checkbox" checked={notifyBounces} onChange={(e) => setNotifyBounces(e.target.checked)} /> Notify Bounces
                        </div>
                        <div>
                        <input type="checkbox" checked={notifyRefunds} onChange={(e) => setNotifyRefunds(e.target.checked)} /> Notify Refunds
                        </div>
                      </div>
                       <div style={{display:'flex',alignItems:'center',marginBottom:'10px',width:'100%'}}>
                      <div style={{ marginBottom: '4px', marginLeft: '10px',marginTop:'10px',width:"50%" }}>
                        
                        <label htmlFor="institutePOCs" style={{ fontSize: '16px', fontWeight: '600' }}>
                          Refund POCs (Emails)
                        </label>

                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '6px',
                            border: '1px solid #ccc',
                            borderRadius: '6px',
                            padding: '6px',
                            minHeight: '10px',
                            maxWidth:'300px'
                          }}
                        >
                          {emails.map((email, index) => (
                            <div
                              key={index}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                backgroundColor: '#f0f0f0',
                                padding: '4px 8px',           
                                borderRadius: '6px',         
                                fontSize: '13px',              
                                width: '100%',             
                                height: '24px',                
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)', 
                                boxSizing: 'border-box',
                              }}
                            >
                              <span
                                style={{
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  flex: 1,
                                  marginRight: '12px',
                                }}
                              >
                                {email}
                              </span>
                              <span
                                style={{
                                  cursor: 'pointer',
                                  fontSize: '20px',
                                  fontWeight: 'bold',
                                  color: '#555',
                                  flexShrink: 0,
                                  width: '24px',
                                  textAlign: 'center',
                                }}
                                onClick={() =>
                                  setEmails(emails.filter((_, i) => i !== index))
                                }
                              >
                                ×
                              </span>
                            </div>
                          ))}

                          <input
                            type="email"
                            style={{
                              border: 'none',
                              outline: 'none',
                              fontSize: '13px',
                              padding: '6px 4px',
                              width: '100%',
                              boxSizing: 'border-box',
                            }}
                            placeholder="Type email and press Enter"
                            value={currentEmail}
                            onChange={(e) => setCurrentEmail(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' && currentEmail.trim()) {
                                setEmails([...emails, currentEmail.trim()]);
                                setCurrentEmail('');
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                      
                      <div style={{ display: 'flex', flexDirection: 'column',width:"50%" }}>
                        <p style={{ fontWeight: '600', marginBottom: '4px' }}>Fibe MID</p>

                        {/* Show existing saved MID if present */}
                        {fibeMid && !fibeMidEditing ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{
                              padding: '4px 10px',
                              backgroundColor: '#f0f0f0',
                              borderRadius: '6px',
                              fontSize: '13px',
                              fontWeight: '500',
                            }}>
                              {fibeMid}
                            </span>
                            <MuiButton
                              size="small"
                              variant="outlined"
                              color="secondary"
                              sx={{ textTransform: 'none' }}
                              onClick={() => {
                                setFibeMidInput(fibeMid);
                                setFibeMidEditing(true);
                              }}
                            >
                              Edit
                            </MuiButton>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Input
                              style={{ width: '17em' }}
                              type="text"
                              placeholder="Enter Fibe MID"
                              value={fibeMidInput}
                              onChange={(e) => setFibeMidInput(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSaveFibeMid();
                              }}
                            />
                            <MuiButton
                              size="small"
                              variant="contained"
                              disabled={fibeMidLoading || !fibeMidInput.trim()}
                              onClick={handleSaveFibeMid}
                              sx={{ textTransform: 'none', backgroundColor: '#D32028' }}
                            >
                              {fibeMidLoading ? 'Saving...' : 'Save'}
                            </MuiButton>
                            {fibeMidEditing && (
                              <MuiButton
                                size="small"
                                variant="outlined"
                                sx={{ textTransform: 'none' }}
                                onClick={() => setFibeMidEditing(false)}
                              >
                                Cancel
                              </MuiButton>
                            )}
                          </div>
                        )}
                      </div>
                      </div>
                      
                       <div style={{display:'flex',justifyContent:'space-between'}}>
                        <FormGroup>
                          <Label htmlFor="signatoryDesignation"><span style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'600'}}>Signatory Designation</span><span style={{color:'red'}}>*</span></Label>
  
                          <Input 
                            style={{width:"17em",height:'2.5em'}}
                            type="text"
                            name="signatoryDesignation"
                            id="signatoryDesignation"
                            placeholder="signatoryDesignation"
                            onChange={(e) => setSignatoryDesignation(e.target.value)}
                            defaultValue={InstituteId?.InstituteId?.signatoryDesignation || ''}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label htmlFor="signatoryName"><span style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'600'}}>Signatory Name</span><span style={{color:'red'}}>*</span></Label>
  
                          <Input 
                            style={{width:"17em",height:'2.5em'}}
                            type="text"
                            name="signatoryName"
                            id="signatoryName"
                            placeholder="signatoryName"
                            onChange={(e) => setSignatoryName(e.target.value)}
                            defaultValue={InstituteId?.InstituteId?.signatoryName || ''}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label htmlFor="notes"><span style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'600'}}>Policy</span><span style={{color:'red'}}>*</span></Label>
                          <Input
                            style={{width:"17em",height:'6em'}}
                            type="textarea"
                            name="notes"
                            id="notes"
                            placeholder="Policy"
                            onChange={(e) => setNotes(e.target.value)}
                            defaultValue={InstituteId?.InstituteId?.notes || ''}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label htmlFor="fundSource"><span style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'600'}}>Fund Source</span></Label>
                          <Input
                            type="select"
                            id="fundSource"
                            name="fundSource"
                            value={fundSource}
                            onChange={(e) => setFundSource(e.target.value)}
                            style={{width:'17em'}}
                          >
                            <option value="">Select</option>
                            <option value="1">GBP</option>
                            <option value="2">FIB</option>
                            <option value="3">Manual</option>
                          </Input>
                        </FormGroup>
                        </div>
                        
                      {/* <div style={{display:'flex',justifyContent:'space-between'}}>
                        <div>
                          <p style={{marginTop: '1em',fontWeight:'600'}}><span >GST Number</span></p>
                          
                        <Input id="insGst" defaultValue={InstituteId?.InstituteId?.gstNumber || ''} onChange={(e)=>setUpdateGSTNumber(e.target.value)} type="text" placeholder="GST Number"/> 
                          </div>
                         {InstituteId?.InstituteId?.logo ?  <img style={{width:'6em',marginRight:'10em'}} alt='logo' id="image" src ={InstituteId.InstituteId.logo}/> : null}
                        </div> */}
                    </div>
                    <Button style={{marginLeft:'40%',width:'10em',backgroundColor:'#D32028',border:'none'}}
                        onClick={() => updateDetailsOfInstitute()}
                      >
                     <span style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'500', textTransform: 'capitalize',color:'white'}}>Update Details</span>
                      </Button>
            </FormGroup>
          </Form>
                ):(
                    <div style={{ marginTop: '20px' }}>
                      
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          marginBottom: '18px',
                          flexWrap: 'wrap'
                        }}
                      >
                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <label style={{ fontWeight: '600', fontSize: '13px' }}>
                            Search Course:
                          </label>

                          <div style={{ position: 'relative' }}>
                           <input
                              type="text"
                              value={courseSearchText}
                              onChange={(e) => {
                                const value = e.target.value;
                                setCourseSearchText(value);
                                
                                if (!value.trim()) {
                                  handleClearCourseSearch();
                                  return;
                                }

                                if (value.trim().length >= 4) {
                                  searchCoursesByName(value);
                                }
                              }}
                              placeholder="Search Courses"
                              style={{
                                width: '200px',
                                height: '32px',
                                padding: '2px 28px 2px 8px', 
                                border: '1px solid #d0d5dd',
                                borderRadius: '6px',
                                fontSize: '13px',
                                outline: 'none',
                              }}
                              onFocus={(e) => {
                                e.target.style.border = '2px solid #4a90e2';
                              }}
                              />
                              {courseSearchText && (
                              <span
                                onClick={handleClearCourseSearch}
                                style={{
                                  position: 'absolute',
                                  right: '8px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                  color: '#999',
                                  fontWeight: 'bold'
                                }}
                              >
                                ×
                              </span>
                            )}
                            {showCourseSearchResults && courseSearchResults.length > 0 && (
                              <div
                                style={{
                                  position: 'absolute',
                                  top: '36px',
                                  left: 0,
                                  width: '100%',
                                  backgroundColor: '#fff',
                                  border: '1px solid #d0d5dd',
                                  borderRadius: '6px',
                                  boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                                  zIndex: 1000,
                                  maxHeight: '180px',
                                  overflowY: 'auto'
                                }}
                              >
                                {courseSearchResults.map((item) => (
                                  <div
                                    key={item.id}
                                    onClick={() => handleSelectSearchedCourse(item)}
                                    style={{
                                      padding: '8px 10px',
                                      cursor: 'pointer',
                                      fontSize: '13px',
                                      borderBottom: '1px solid #f0f0f0',
                                      backgroundColor: '#fff'
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = '#f8f9fb';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = '#fff';
                                    }}
                                  >
                                    {item.courseName || '-'}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      
                        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                          <label style={{ fontWeight: '600', fontSize: '13px' }}>
                            Status:
                          </label>

                          <select
                            value={courseFilterStatus}
                            onChange={(e) => {
                              const value = e.target.value;
                              setCourseFilterStatus(value);
                         if (selectedCourseId) {
                                fetchSelectedCourseById(selectedCourseId, value);
                              } else {
                                fetchCourses(value, instituteId, 1, courseSearchText);
                              }
                            }}
                            style={{
                              width: '100px',
                              height: '32px',
                              padding: '2px 4px',
                              border: '1px solid #d0d5dd',
                              borderRadius: '6px',
                              fontSize: '13px',
                              outline: 'none',
                              marginLeft:'2px'
                            }}
                          >
                            <option value="">All</option>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                          </select>
                        </div>
                        <button
                          type="button"
                          onClick={()=>setShowCreateCoursePopup(true)}
                          disabled={createCourseLoading}
                          style={{
                            backgroundColor: '#D32028',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '6px 14px',
                            fontSize: '13px',
                            height: '32px',
                            display: 'flex',              
                            alignItems: 'center',       
                            justifyContent: 'center',    
                            cursor: createCourseLoading ? 'not-allowed' : 'pointer',
                            marginLeft:'10px'
                          }}
                        >
                          {createCourseLoading ? 'Saving...' : 'Add Course'}
                        </button>
                        <button
                          type="button"
                          onClick={handleClearCourseFilters}
                          style={{
                            backgroundColor: '#d32028',
                            color: 'white',
                            border: '1px solid #D32028',
                            borderRadius: '6px',
                            padding: '6px 10px',
                            fontSize: '13px',
                            height: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            marginLeft: '6px',
                            gap: '4px'
                          }}
                        >
                          <RefreshIcon style={{ fontSize: '16px' }} />
                        
                        </button>
                      </div>
                    

                      {courseLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>Loading courses...</div>
                      ) : courseError ? (
                        <div style={{ textAlign: 'center', color: 'red', padding: '20px' }}>
                          {courseError}
                        </div>
                      ) : courseList.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>No courses found</div>
                      ) : (
                        <div>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <thead>
                            <tr style={{ backgroundColor: '#f3f3f3' }}>
                              <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Course Name</th>
                              <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Fees</th>
                                  
                                    <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Status</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center',width:'150px' }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                                  {courseList.map((course) => (
                              <tr key={course.id}>
                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                  {course.courseName || '-'}
                                </td>
                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                  {course.fees ?? '-'}
                                </td>
                                <td style={{ padding: '8px', border: '1px solid #ddd',textAlign:'center' }}>
                                  <span
                                    style={{
                                      padding: '10px 12px',
                                      borderRadius: '20px',
                                      fontSize: '12px',
                                      fontWeight: '500',
                                      backgroundColor: course.status ? '#E6F4FF' : '#FDECEC',
                                      color: course.status ? '#1677FF' : '#D32028'
                                    }}
                                  >
                                    {course.status ? 'Active' : 'Inactive'}
                                  </span>
                                </td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                  <img
                                    src={edit}
                                    alt="edit"
                                    onClick={() => openCourseStatusPopup(course)}
                                    style={{
                                      width: '16px',
                                      height: '16px',
                                      cursor: 'pointer',
                                      opacity: statusUpdatingId === course.id ? 0.5 : 1
                                    }}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      {totalCourseRows > coursesPerPage && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    width:'100%',
                      marginTop: '12px'
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => {
                        const newPage = Math.max(coursePage - 1, 1);
                        fetchCourses(courseFilterStatus, instituteId, newPage, courseSearchText);
                      }}
                      disabled={coursePage === 1}
                      style={{
                        border: '1px solid #d0d5dd',
                        backgroundColor: coursePage === 1 ? '#f5f5f5' : '#fff',
                        color: '#333',
                        borderRadius: '4px',
                        padding: '2px 8px',
                        cursor: coursePage === 1 ? 'not-allowed' : 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Prev
                    </button>

                    <span style={{ fontSize: '12px', fontWeight: '500' }}>
                      Page {coursePage} of {totalCoursePages}
                    </span>

                    <button
                      type="button"
                      onClick={() =>{
                        const newPage = Math.min(coursePage + 1, totalCoursePages);
                        fetchCourses(courseFilterStatus, instituteId, newPage, courseSearchText);
                      }}
                      disabled={coursePage === totalCoursePages}
                      style={{
                        border: '1px solid #d0d5dd',
                        backgroundColor: coursePage === totalCoursePages ? '#f5f5f5' : '#fff',
                        color: '#333',
                        borderRadius: '6px',
                        padding: '4px 10px',
                        cursor: coursePage === totalCoursePages ? 'not-allowed' : 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Next
                    </button>
                  </div>
                )}
                  </div>      
                      )}
                      {showCreateCoursePopup && (
                        <Modal
                          isOpen={showCreateCoursePopup}
                          toggle={() => setShowCreateCoursePopup(false)}
                          centered
                        >
                          <ModalHeader toggle={() => setShowCreateCoursePopup(false)}>
                            Add Course
                          </ModalHeader>

                          <ModalBody>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                <label style={{ fontWeight: '600', fontSize: '13px' }}>
                                  Course Name
                                </label>
                                <input
                                  type="text"
                                  value={courseName}
                                  onChange={(e) => setCourseName(e.target.value)}
                                  placeholder="Enter course name"
                                  style={{
                                    width: '100%',
                                    height: '36px',
                                    padding: '6px 10px',
                                    border: '1px solid #d0d5dd',
                                    borderRadius: '6px',
                                    fontSize: '13px',
                                    outline: 'none',
                                  }}
                                />
                              </div>

                              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                <label style={{ fontWeight: '600', fontSize: '13px' }}>
                                  Course Fees
                                </label>
                                <input
                                  type="number"
                                  value={courseFees}
                                  onChange={(e) => setCourseFees(e.target.value)}
                                  placeholder="Enter course fees"
                                  style={{
                                    width: '100%',
                                    height: '36px',
                                    padding: '6px 10px',
                                    border: '1px solid #d0d5dd',
                                    borderRadius: '6px',
                                    fontSize: '13px',
                                    outline: 'none',
                                  }}
                                />
                              </div>

                              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '8px' }}>
                                <Button
                                  color="secondary"
                                  onClick={() => {
                                    setShowCreateCoursePopup(false);
                                    setCourseName("");
                                    setCourseFees("");
                                  }}
                                >
                                  Cancel
                                </Button>

                                <Button
                                  color="primary"
                                  onClick={handleCreateCourse}
                                  disabled={createCourseLoading}
                                >
                                  {createCourseLoading ? "Adding..." : "Add"}
                                </Button>
                              </div>
                            </div>
                          </ModalBody>
                        </Modal>
                      )}
                      {/* model for statuss */}
                      {selectedCourseForStatus && (
                        <Modal
                          isOpen={!!selectedCourseForStatus}
                          toggle={() => setSelectedCourseForStatus(null)}
                          centered
                        >
                          <ModalHeader toggle={() => setSelectedCourseForStatus(null)}>
                            Confirm Status Change
                          </ModalHeader>
                          <ModalBody>
                            <p style={{ marginBottom: '16px', fontSize: '14px' }}>
                              Do you want to make this course{" "}
                              <strong>{selectedCourseForStatus.status ? "Inactive" : "Active"}</strong>?
                            </p>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                              <Button
                                color="secondary"
                                onClick={() => setSelectedCourseForStatus(null)}
                              >
                                Cancel
                              </Button>

                              <Button
                                color={selectedCourseForStatus.status ? "danger" : "primary"}
                                onClick={() => handleCourseStatusChange(selectedCourseForStatus)}
                                disabled={statusUpdatingId === selectedCourseForStatus.id}
                              >
                                {statusUpdatingId === selectedCourseForStatus.id
                                  ? "Updating..."
                                  : selectedCourseForStatus.status
                                    ? "Deactivate"
                                    : "Activate"}
                              </Button>
                            </div>
                          </ModalBody>
                        </Modal>
                      )}
                    </div>
                )}
        </ModalBody>
       
          </div>
          
        
      </Modal>
      </>
       )}
    </div>
  );
}
